import { FC } from 'react'
import { FormItem, MultiSelect } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { reportingTranslations } from 'locale/reporting'
import { FormInstance, Select } from 'antd'
import { useGroupedCarers } from 'hooks/useGroupedOptions'
import { useSelector } from 'react-redux'
import { Home } from '@lmc/ts-common'

type Props = { form?: FormInstance<any>; isGroupDownload?: boolean }

export const TeamMemberExportForm: FC<Props> = ({ form, isGroupDownload }) => {
  const { t } = useTranslation(NAMESPACE.REPORTING)

  const { groupedCarerOptions } = useGroupedCarers(isGroupDownload)

  const homes = useSelector(
    (state: { data: { homes: Home[] } }) => state.data.homes
  )

  const homeOptions = homes.map((home) => ({
    value: home?.id,
    label: home?.name,
  }))

  return (
    <>
      <FormItem
        label={t(reportingTranslations.TEAM_MEMBERS_TITLE)}
        name="carers"
        extra={t(reportingTranslations.SELECT_ENTITY, {
          variable: t(reportingTranslations.TEAM_MEMBERS_TITLE),
        })}
      >
        <MultiSelect
          title="Team members"
          groupedOptions={groupedCarerOptions}
          hasClear
          hasSearch
          hasSelectAll
          onChange={(values) => form?.setFieldValue('carers', values)}
          placeholder={false}
        />
      </FormItem>
      {isGroupDownload && (
        <FormItem
          label={t(reportingTranslations.SITES)}
          name="sites"
          extra={t(reportingTranslations.SITES_EXTRA)}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select options={homeOptions} mode="multiple" />
        </FormItem>
      )}
    </>
  )
}
